module.exports = __webpack_public_path__ + "static/media/admin_user-edit.d91624ec.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/admin_user-edit.md
// module id = 1082
// module chunks = 0